import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';

import { releaseNotesSuccess } from './actions';

import initialState from './states';

export default handleActions(
  {
    [releaseNotesSuccess](state, { payload }) {
      return {
        ...state,
        items: Object.freeze(Array.isArray(payload) ? payload : []),
        loaded: true,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
